import palette from '../../palette';

const buttonPadding = "10px 20px";
export default {
  contained: {
    backgroundColor: palette.blueMain,
    borderRadius: "4px",
    padding: buttonPadding,
    lineHeight: "1.2",
    boxShadow: "none", // "0px 2px 10px rgba(0, 0, 0, 0.3)",
    "&:hover": {
      backgroundColor: palette.greenDark,
      "@media (hover: none)": {
        backgroundColor: palette.greenDark,
      },
    },
    "&$disabled": {
      backgroundColor: palette.grayDisable
    },
    borderRadius: "4px",
    padding: buttonPadding,
    fontSize: "18px",
    color: palette.white
  },
  text: {
    color: palette.greenDark
  },
  outlined: {
    color: palette.greenDark
  }
};
